import { type ReactNode } from 'react';
import { RouterProvider } from '@direct-frontend/components';
import { useNavigate } from '@direct-frontend/modules-router';
import { HistoryRouter, type HistoryRouterProps } from '@direct-frontend/modules-router/client';

/**
 * Провайдер контекста роутера на клиенте
 * @kind component
 */
export function Router(props: HistoryRouterProps) {
    const { children, ...historyRouterProps } = props;

    return (
        <HistoryRouter {...historyRouterProps}>
            <RouterNavigateProvider>{children}</RouterNavigateProvider>
        </HistoryRouter>
    );
}

/*
 * Предоставляет методы навигации для библиотеки компонентов
 */
function RouterNavigateProvider(props: { children: ReactNode }) {
    const navigate = useNavigate();

    return <RouterProvider navigate={navigate}>{props.children}</RouterProvider>;
}
